module.exports = __webpack_public_path__ + "img/chat.55f282b2.svg";